import { render, staticRenderFns } from "./DescriptionDataSet.vue?vue&type=template&id=e3aaecd2&scoped=true"
import script from "./DescriptionDataSet.vue?vue&type=script&lang=ts"
export * from "./DescriptionDataSet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3aaecd2",
  null
  
)

export default component.exports